import { render, staticRenderFns } from "./OdontogramDetail.vue?vue&type=template&id=d5f94b9a"
import script from "./OdontogramDetail.vue?vue&type=script&lang=js"
export * from "./OdontogramDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports